
type Channel = 'nfc' | 'qr' | 'cash' | 'zazu' | 'card';

const CHANNELS: Record<Channel, { icon: string; label: string }> = {
  nfc:  { icon: 'contactless',            label: 'NFC' },
  qr:   { icon: 'qr_code_2',             label: 'QR' },
  cash: { icon: 'payments',              label: 'Cash' },
  zazu: { icon: 'account_balance_wallet', label: 'ZAZU' },
  card: { icon: 'credit_card',           label: 'Carte' },
};

interface Props {
  channel: Channel | string | null;
  size?: 'sm' | 'md';
}

export default function ChannelBadge({ channel, size = 'md' }: Props) {
  if (!channel) return null;
  const meta = CHANNELS[channel as Channel] ?? { icon: 'payments', label: channel };
  const iconSize = size === 'sm' ? 'text-[14px]' : 'text-[16px]';
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 bg-surface-container text-on-surface ${textSize} font-semibold uppercase tracking-wider`}
      style={{ border: '0.5px solid #e5e7eb' }}
    >
      <span className={`material-symbols-outlined ${iconSize}`}>{meta.icon}</span>
      {meta.label}
    </span>
  );
}
